<template>
    <v-card class="mx-4" elevation="4">
        <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
            <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras 
        </v-btn>

        <v-list-item three-line>
        <v-list-item-content>
            <div class="text-overline mb-4">
            
            </div>
            <v-list-item-title class="text-h5 mb-1">
                Lista de estados de titulacion
            </v-list-item-title>
            <v-list-item-subtitle></v-list-item-subtitle>
        </v-list-item-content>

        <v-btn class="green darken-4" dark tile @click="registrar()">
            <v-icon left>mdi-plus</v-icon>
            Registrar nuevo
        </v-btn>

        </v-list-item> 

        <template>
            <v-data-table
                :headers="headers"
                :items="datos"
                :items-per-page="500"
                dense
                disable-pagination
                hide-default-footer
                class="elevation-1"
            >

            <template v-slot:[`item.color`]="{ item }">
                <span :style="'width:20px;height:22px;display:inline-block;background-color:'+item.color"></span>
                <span> {{ item.color }} </span>
            </template>

            <template v-slot:[`item.estado`]="{ item }">
                <span> {{ item.estado?'Activo':'Inactivo' }} </span>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
                <!-- <v-btn small text class="red--text" title="Cambiar estado" @click="cambiarEstadoTit(item)">
                    <v-icon>mdi-delete</v-icon>
                </v-btn> -->

                <v-btn small text class="orange--text" title="Editar estado" @click="registrar(item)">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </template>

            </v-data-table>
        </template>

        <Form ref="formregistro" v-on:reload="listarDatos"/>
    </v-card>
</template>

<script>
import {getHeaders,cambiarEstado} from './estados_titulaciones.js';
import {getEstadosTitulacion} from './index.js'
import Form from './crear/registrar.vue'

export default {
    components: { 
        Form
    },
    data() {
      return {
        loading: false, 
        headers: [],
        datos: [], 
      };
    }, 
    methods: {
        async listarDatos(){ 
            this.datos = [];
            const data = await getEstadosTitulacion(this); 
            this.datos = data;
            window.console.log(data);
        },
        registrar(edit){
            this.$refs.formregistro.openmodal(edit);
        },
        async cambiarEstadoTit(t){
            window.console.log(t);
            const res = await cambiarEstado(this, t.id, t.estado?false:true);
            if(res.ok){
                this.$root.$notify.show('Estado cambiado correctamente',{color:'green',x: 'right'});
            }else if (res.errors){
                const er = res.errors[0].message
                this.$root.$notify.show(er,{color:'red',x: 'right'});
            }
            window.console.log(res);
        }
    },
    async mounted() {  
        this.headers = getHeaders(); 
        this.listarDatos();
    },
  };
</script>
./por_programas.js